import { CheckCircle2 } from "lucide-react";

const benefits = [
  "Fund-raising collaboration with institutional frameworks",
  "Investor onboarding support through structured processes",
  "Structured execution participation in capital deployment",
  "Long-term compliant revenue opportunities",
  "Access to institutional-grade tools and resources",
  "Ongoing professional development and ecosystem support",
];

export default function PartnerOpportunity() {
  return (
    <section
      className="relative py-20 md:py-24 px-6 md:px-12 lg:px-24
      bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
      overflow-hidden"
    >
      {/* grid overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-20"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Partner Opportunity
          </h2>
          <p className="text-base sm:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Join the AQT Direct Partner Ecosystem and become part of a professional
            network committed to institutional excellence in capital markets
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-white/10 backdrop-blur-md
              rounded-xl p-6 flex items-start gap-4
              border border-white/10
              hover:border-[#0E6F7E]
              hover:bg-white/15
              transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex-shrink-0 mt-1">
                <CheckCircle2 className="w-6 h-6 text-[#1DBF73] group-hover:scale-110 transition-transform duration-300" />
              </div>
              <p className="text-base md:text-lg text-gray-100 leading-relaxed">
                {benefit}
              </p>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="mt-12 pt-10 border-t border-white/10">
          <p className="text-center text-gray-300 text-lg max-w-4xl mx-auto leading-relaxed">
            Partners in the AQT Direct ecosystem benefit from institutional
            alignment, regulatory support, and long-term participation in
            structured capital deployment opportunities.
          </p>
        </div>
      </div>
    </section>
  );
}
